<template>
  <div>
    <p class="font-xtypewriter text-[1.25rem] leading-[1.75rem]">
      Love and Respect,<br />Pastor How<br />Father’s Day {{ year }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    year: {
      type: String,
      default: '',
    },
  },
};
</script>
